import { defineMessageUnion } from "foldkit/message";

import { TagInputVariant } from "./model";

export const Message = defineMessageUnion({
	CompletedReadVariant: { variant: TagInputVariant },
	SelectedVariant: { variant: TagInputVariant },
	CompletedPersistVariant: {},
});
export type Message = typeof Message.Type;
